import { Badge } from '@/components/ui/badge';
import type { ContentExternalRefSummary } from '@vivport/backend/types';

interface ContentExternalRefChipProps {
  externalRefs: ContentExternalRefSummary[];
}

export function ContentExternalRefChip({ externalRefs }: ContentExternalRefChipProps) {
  const ref = externalRefs.find((entry) => entry.provider === 'XERO' && entry.resourceType === 'INVOICE');
  if (!ref) {
    return null;
  }
  return (
    <Badge
      variant="outline"
      className="shrink-0 font-normal text-muted-foreground"
      data-testid="content-external-ref-chip"
    >
      Xero · {ref.resourceLabel ?? ref.resourceId.slice(0, 8)}
    </Badge>
  );
}
